/**
 * THE PHOTOGRAPH STRIP (P-PHOTO-01, OR-2). OWNER: web-frontend-engineer.
 *
 * One set's shots, as the client screen shows them and as the cut tickets
 * print them: each from its own audited route, never cropped, its pose named
 * under it, in the order the server gives them (by `seq`). Moved here out of
 * Clients.tsx on 18 October 2026 (the LAW 59 review), so the tickets'
 * photographs page reuses the strip rather than keeping a second one of its own.
 *
 * `size="tickets"`: three across, as large as three across allows, for the
 * page that goes to the factory with the bundle. The default is the client
 * screen's strip, a portrait's width each.
 */

import { t } from '@pt/copy';
import { api } from '../lib/api.ts';
import type { PhotographRow } from '../lib/contracts.ts';

export interface PhotographStripProps {
  readonly photographs: readonly PhotographRow[];
  readonly size?: 'tickets';
}

export function PhotographStrip({ photographs, size }: PhotographStripProps) {
  return (
    <ul className={size === 'tickets' ? 'pt-photoStrip pt-photoStrip--tickets' : 'pt-photoStrip'}>
      {photographs.map((photograph) => (
        <li key={photograph.photographId}>
          {/* The bytes come from their own audited route: the browser carries
              the session cookie, and the read is logged with the reader's name
              like every other read of a body. */}
          <img
            className="pt-photoStrip__shot"
            src={api.photographUrl(photograph.photographId)}
            alt={t('client.photographs.pose', { poseName: photograph.pose })}
          />
          <span className="pt-photoStrip__pose">
            {t('client.photographs.pose', { poseName: photograph.pose })}
          </span>
        </li>
      ))}
    </ul>
  );
}
